import * as api from '../salesCallApi';
import { businessEntityActionCreators } from '../../businessEntity';
import {
  call,
  put,
  select,
  takeEvery
  } from 'redux-saga/effects';
import {
  DeleteSalesCall,
  ISalesCall,
  salesCallActionCreators,
  SalesCallActionKeys
  } from '..';
import { getSalesCall } from '../salesCallSelectors';
import { uiActionCreators } from '../../ui';

function* deleteSalesCallSaga(action: DeleteSalesCall) {
  yield put(uiActionCreators.showSpinnerDialog());
  const salesCallId: number = yield call(api.deleteSalesCall, action.payload);
  const salesCall: ISalesCall = yield select(getSalesCall, action.payload);

  if (salesCall) {
    yield put(businessEntityActionCreators.removeSalesCall(salesCall));
  }

  yield put(salesCallActionCreators.deleteSalesCallFulfilled(salesCallId));
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteSalesCall() {
  yield takeEvery(SalesCallActionKeys.DELETE_SALESCALL, deleteSalesCallSaga);
}
